import styled from 'styled-components';

type TabsContainer = {
    isCameraMode?: boolean;
};

export const TabContainer = styled.div<TabsContainer>`
    padding: 16px;
    max-width: ${(props) => (props.isCameraMode ? '1200px' : '632px')};
    margin: auto;
    width: 100%;

    .upload-title-container {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 12px;
        margin-top: 12px;
        margin-bottom: 24px;

        .upload-title {
            margin: 0;
        }
    }

    .switch-liveness {
        margin-left: 0;
    }

    .main {
        display: flex;
        flex-wrap: wrap-reverse;

        &-liveness {
            justify-content: center;
        }
    }

    .upload-container {
        width: 100%;
    }

    .tabs-container {
        .tab__item {
            display: flex;
            flex: 1 1 0;
            width: 0;
        }

        .MuiTabs-list {
            ${(props) => props.theme.breakpointTo.xs} {
                gap: 10px;
            }

            @media (max-width: 380px) {
                gap: 4px;
            }
        }

        .MuiButtonBase-root {
            justify-content: flex-start;
            align-items: flex-end;
            padding-bottom: 4px;
            width: 100%;

            span {
                text-align: left;
            }

            @media (max-width: 354px) {
                font-size: 11px;
            }
        }
    }

    .header-container {
        display: flex;
        flex-direction: column;
        gap: 16px;

        .language-selector {
            width: 160px;
            margin-left: auto;
        }

        .arrow-icon {
            transform: rotate(180deg);
            cursor: pointer;
        }
    }

    .header-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;
    }

    .steps-title {
        margin-top: 0;
        margin-bottom: 0;
        text-align: center;

        > span {
            color: ${(props) => props.theme.palette.primaryA1};
            border-bottom: 1px solid ${(props) => props.theme.palette.primaryA1};
        }

        .timer {
            margin-top: 16px;
        }
    }

    .skip-button {
        margin-top: 48px;
    }

    .btn__tab-redirect {
        margin-top: 24px;
    }
`;
